import { useServicesChartsDataContext } from '../../../hooks/useServicesChartsDataContext';
import { years } from '../../../../Filters/Filters';
import { defaultColors } from '../../../contexts/ServicesChartsDataContext';

const useServicesPerYearPercentageChart = () => {
    const { chartData, subtitles } = useServicesChartsDataContext();

    const totalPerYear = years.map((year) => {
        const found = chartData.counterYear
            .filter((counter) => counter.ano_competencia === year)
            .reduce((acc, curr) => acc + Number(curr.services), 0);

        return found ? Number(found) : 0;
    });

    const series = subtitles.map((item) => {
        const data = years.map((year, index) => {
            if (totalPerYear[index] === 0) {
                return 0;
            }

            const found = chartData.counterYear.find(
                (counter) =>
                    (counter.description ?? '-') === item &&
                    counter.ano_competencia === year
            );

            return found
                ? (
                      (Number(found.services) / totalPerYear[index]) *
                      100
                  ).toFixed(2)
                : 0;
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last'
                }
            },
            yaxis: {
                max: 100
            },
            xaxis: {
                categories: years || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#ffffff'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                y: {
                    formatter: (val) => (val ? `${val.toLocaleString('pt-BR')}%` : '')
                }
            },
            colors: defaultColors,
            grid: {
                show: false
            }
        }
    };

    return {
        chartConfig
    };
};

export default useServicesPerYearPercentageChart;
